(function () {
  if (window.__anInit) return;
  window.__anInit = true;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var observer = null;

  function getObserver() {
    if (observer) return observer;
    if (!('IntersectionObserver' in window)) return null;
    observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('an-visible');
          observer.unobserve(e.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
    return observer;
  }

  function initReveals(root) {
    var els = (root || document).querySelectorAll('.an-reveal, .an-caja, .an-pasos');
    var obs = getObserver();
    els.forEach(function (el) {
      if (el.dataset.anRev) return;
      el.dataset.anRev = '1';
      if (!obs || reduce) { el.classList.add('an-visible'); return; }
      obs.observe(el);
    });
  }

  function initHero(root) {
    (root || document).querySelectorAll('.an-hero').forEach(function (el) {
      if (el.dataset.anInit) return;
      el.dataset.anInit = '1';
      requestAnimationFrame(function () { setTimeout(function () { el.classList.add('an-cargado'); }, 60); });
    });
  }

  function initManifiesto(root) {
    (root || document).querySelectorAll('[data-an-manifiesto]').forEach(function (el) {
      if (el.dataset.anInit) return;
      el.dataset.anInit = '1';
      var palabras = el.querySelectorAll('.an-palabra');
      if (!palabras.length) return;
      if (reduce) { palabras.forEach(function (p) { p.classList.add('on'); }); return; }
      el.setAttribute('data-an-listo', '');
      var ticking = false;
      function update() {
        ticking = false;
        var r = el.getBoundingClientRect();
        var vh = window.innerHeight;
        var start = vh * 0.85, end = vh * 0.35;
        var prog = (start - r.top) / ((start - end) + r.height * 0.6);
        prog = Math.max(0, Math.min(1, prog));
        var n = Math.round(prog * palabras.length);
        palabras.forEach(function (p, i) { p.classList.toggle('on', i < n); });
      }
      window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
      update();
    });
  }

  function initEscenarios(root) {
    (root || document).querySelectorAll('[data-an-escenarios]').forEach(function (el) {
      if (el.dataset.anInit) return;
      el.dataset.anInit = '1';
      var tabs = el.querySelectorAll('.an-esc__tab');
      var escenas = el.querySelectorAll('.an-esc__escena');
      tabs.forEach(function (t, i) {
        t.addEventListener('click', function () {
          tabs.forEach(function (x, j) { x.setAttribute('aria-selected', j === i ? 'true' : 'false'); });
          escenas.forEach(function (x, j) { x.classList.toggle('activa', j === i); });
        });
      });
    });
  }

  function formatoCLP(n) {
    return '$' + Math.round(n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }

  function countTo(el, valor, esDinero) {
    var desde = parseFloat(el.dataset.valor || '0');
    el.dataset.valor = valor;
    if (reduce) { el.textContent = esDinero ? formatoCLP(valor) : Math.round(valor); return; }
    var t0 = null, dur = 500;
    function paso(ts) {
      if (!t0) t0 = ts;
      var p = Math.min(1, (ts - t0) / dur);
      var v = desde + (valor - desde) * (1 - Math.pow(1 - p, 3));
      el.textContent = esDinero ? formatoCLP(v) : Math.round(v);
      if (p < 1) requestAnimationFrame(paso);
    }
    requestAnimationFrame(paso);
  }

  function initCalculadora(root) {
    (root || document).querySelectorAll('[data-an-calc]').forEach(function (el) {
      if (el.dataset.anInit) return;
      el.dataset.anInit = '1';
      var ml = el.querySelector('[name=an-ml]');
      var tam = el.querySelector('[name=an-tam]');
      var precio = el.querySelector('[name=an-precio]');
      var costoPack = parseFloat(el.dataset.costoPack || '0');
      var costoAtom = parseFloat(el.dataset.costoAtom || '0');
      var merma = parseFloat(el.dataset.merma || '0') / 100;
      var outMl = el.querySelector('[data-out=ml]');
      var outTam = el.querySelector('[data-out=tam]');
      var outPrecio = el.querySelector('[data-out=precio]');
      var rDec = el.querySelector('[data-res=decants]');
      var rIng = el.querySelector('[data-res=ingresos]');
      var rGan = el.querySelector('[data-res=ganancia]');
      function calc() {
        var totalMl = parseFloat(ml.value) * 3 * (1 - merma);
        var n = Math.floor(totalMl / parseFloat(tam.value));
        var ingresos = n * parseFloat(precio.value);
        var ganancia = ingresos - costoPack - n * costoAtom;
        outMl.textContent = ml.value + ' ml';
        outTam.textContent = tam.value + ' ml';
        outPrecio.textContent = formatoCLP(parseFloat(precio.value));
        countTo(rDec, n, false);
        countTo(rIng, ingresos, true);
        countTo(rGan, Math.max(0, ganancia), true);
      }
      [ml, tam, precio].forEach(function (i) { i.addEventListener('input', calc); });
      calc();
    });
  }

  function initFaq(root) {
    (root || document).querySelectorAll('.an-faq__item').forEach(function (it) {
      if (it.dataset.anInit) return;
      it.dataset.anInit = '1';
      var btn = it.querySelector('.an-faq__btn');
      btn.addEventListener('click', function () {
        var abierto = it.classList.toggle('abierto');
        btn.setAttribute('aria-expanded', abierto ? 'true' : 'false');
      });
    });
  }

  function initProducto(root) {
    (root || document).querySelectorAll('[data-an-producto]').forEach(function (el) {
      if (el.dataset.anInit) return;
      el.dataset.anInit = '1';
      var principal = el.querySelector('.an-prod__principal img');
      el.querySelectorAll('.an-prod__mini').forEach(function (m) {
        m.addEventListener('click', function () {
          el.querySelectorAll('.an-prod__mini').forEach(function (x) { x.classList.remove('activa'); });
          m.classList.add('activa');
          if (principal) {
            principal.style.opacity = 0;
            setTimeout(function () { principal.src = m.dataset.src; principal.style.opacity = 1; }, 180);
          }
        });
      });
      var dataEl = el.querySelector('[data-an-variantes]');
      if (!dataEl) return;
      var variantes = JSON.parse(dataEl.textContent);
      var idInput = el.querySelector('input[name=id]');
      var btn = el.querySelector('.an-prod__comprar');
      var precio = el.querySelector('.an-prod__actual');
      var tachado = el.querySelector('.an-prod__tachado');
      var moneda = el.dataset.moneda || '';
      function fmt(cents) {
        return '$' + Math.round(cents / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.') + (moneda ? ' ' + moneda : '');
      }
      el.querySelectorAll('.an-prod__opcion input').forEach(function (inp) {
        inp.addEventListener('change', function () {
          var sel = [];
          el.querySelectorAll('.an-prod__opcion fieldset').forEach(function (fs) {
            var c = fs.querySelector('input:checked');
            sel.push(c ? c.value : null);
          });
          var v = variantes.find(function (x) { return x.options.every(function (o, i) { return o === sel[i]; }); });
          if (!v) { btn.disabled = true; btn.querySelector('span').textContent = btn.dataset.noDisp; return; }
          idInput.value = v.id;
          precio.textContent = fmt(v.price);
          if (tachado) { tachado.textContent = v.compare_at_price > v.price ? fmt(v.compare_at_price) : ''; }
          btn.disabled = !v.available;
          btn.querySelector('span').textContent = v.available ? btn.dataset.texto : btn.dataset.agotado;
        });
      });
    });
  }

  function initTodo(e) {
    var root = e && e.target && e.target.nodeType === 1 ? e.target : document;
    initReveals(root);
    initHero(root);
    initManifiesto(root);
    initEscenarios(root);
    initCalculadora(root);
    initFaq(root);
    initProducto(root);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initTodo);
  else initTodo();
  document.addEventListener('shopify:section:load', initTodo);
})();
